import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Dashboard from "../pages/dashboard";
import Clientes from "../pages/clientes";
import Printers from "../pages/printers";
import PrinterDetails from "../pages/detalhes_impressoras";
import Maintenance from "../pages/maintenance";
import Toners from "../pages/toner";
import Login from "../pages/Login"; 
import Register from "../pages/registro"; 
import AppLayout from "../layouts/applayout";
import Laboratory from "../pages/laboratorio";
import LabPrinterDetail from "../pages/LabPrinterDetail";
import CalendarPage from "../pages/Calendario"; 
import TaskgPage from "../pages/tasks"
import SupplyList from "../pages/supplies";
// ========================================================
// 🛡️ O PORTEIRO REAL: Layout Protegido (Padrão Sênior DRY)
// ========================================================
const ProtectedLayout = () => {
  const isAuthenticated = !!localStorage.getItem("token");
  
  if (!isAuthenticated) {
    console.warn("🚫 Acesso negado. Intruso bloqueado pelo Front-end.");
    return <Navigate to="/login" replace />;
  }

  // Se passou, renderiza o AppLayout envelopando a página solicitada
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

// ========================================================
// 👑 PROTEÇÃO NÍVEL DIRETORIA: Só Administradores
// ========================================================
const AdminLayout = () => {
  const role = localStorage.getItem("user_role");
  
  if (role !== "admin") {
    console.warn("⛔ Acesso restrito. Área financeira exclusiva para Administradores.");
    return <Navigate to="/dashboard" replace />;
  }
  
  return <Outlet />;
};

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 🔓 ROTAS PÚBLICAS */}
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Register />} />

        {/* 🔐 ROTAS PROTEGIDAS (O ProtectedLayout envelopa todas elas automaticamente) */}
        <Route element={<ProtectedLayout />}>
          
          {/* Rotas Operacionais (Técnicos e Admins) */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/clients" element={<Clientes />} />
          <Route path="/printers" element={<Printers />} />
          <Route path="/printers/:id" element={<PrinterDetails />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/toner" element={<Toners />} />
          <Route path="/laboratorio" element={<Laboratory />} />
          <Route path="/laboratory/:id" element={<LabPrinterDetail />} />
          <Route path="/calendario" element={<CalendarPage />} />
          <Route path="/tasks" element={<TaskgPage />} />
          <Route path="/supplies" element={<SupplyList />} />

        </Route>

        {/* 🏠 RAIZ DO SITE */}
        <Route path="/" element={
          localStorage.getItem("token") ? 
          <Navigate to="/dashboard" replace /> : 
          <Navigate to="/login" replace />
        } />

        {/* 🚪 ROTA FANTASMA (Se digitar URL que não existe) */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}